<template>
  <div class="footer-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Zarządzanie Stopką</h1>
    </div>

    <div class="footer-layout">
      <div class="section-card">
        <div class="section-card-header">
          <div class="section-card-title position-relative">
            <h2>Kolumna 1 — Copyright</h2>
            <HintComponent page-key="admin_panel_footer_copyright"/>
          </div>

          <button class="btn-primary" @click="currentEditCol = currentEditCol === 1 ? 0 : 1">
            {{ currentEditCol === 1 ? 'Zamknij edycję' : 'Edytuj kolumnę' }}
          </button>
        </div>

        <div class="first-col-preview">
          <img
              v-if="firstCol.firstColData.logo_url"
              :src="firstCol.firstColData.logo_url"
              alt="Logo stopki"
              class="footer-col-logo-img"
          >
          <p v-html="firstCol.firstColData.text"></p>
          <b v-html="firstCol.firstColData.copyright"></b>
        </div>

        <div v-if="currentEditCol === 1" class="form-block">
          <div class="form-group">
            <label for="firstColText">Tekst</label>
            <textarea
                id="firstColText"
                v-model="firstCol.firstColData.text"
                rows="6"
                required
            ></textarea>
          </div>

          <div class="form-group">
            <label for="firstColCopy">Copyright</label>
            <input
                id="firstColCopy"
                type="text"
                v-model="firstCol.firstColData.copyright"
                required
            >
          </div>

          <div class="form-actions">
            <button class="btn-green" @click="uploadCol1Data">Zapisz zmiany</button>
          </div>
        </div>
      </div>

      <div class="section-card">

        <div class="section-card-header">
          <div class="section-card-title position-relative">
            <h2>Kolumna 2 — Media społecznościowe</h2>
            <HintComponent page-key="admin_panel_footer_social_media"/>
          </div>

          <button class="btn-primary" @click="toggleSocialForm">
            {{ currentEditCol === 2 ? 'Zamknij formularz' : '+ Dodaj element' }}
          </button>
        </div>

        <div class="social-list">
          <div class="social-item" v-for="item in secondCol.secondColData" :key="item.id">
            <a :href="item.url" class="social-link" target="_blank" rel="noopener noreferrer">
              <img :src="item.icon_url" :alt="item.name">
              <span>{{ item.name }}</span>
            </a>
            <button class="btn-icon btn-danger" @click="removeSocial(item.id)" title="Usuń">
              <img src="@/assets/icons/trash.svg" alt="usuń">
            </button>
          </div>

          <div v-if="secondCol.secondColData.length === 0" class="empty-state">
            <p>Brak ikon społecznościowych.</p>
          </div>
        </div>

        <div v-if="currentEditCol === 2" class="form-block">
          <div class="form-group">
            <label for="socialName">Nazwa</label>
            <input id="socialName" type="text" v-model="secondCol.newElementName" required>
          </div>

          <div class="form-group">
            <label for="socialUrl">Adres URL</label>
            <input id="socialUrl" type="text" v-model="secondCol.newElementUrl" required>
          </div>

          <div class="form-group">
            <label for="socialIcon">Ikona (png / jpg)</label>
            <input
                id="socialIcon"
                type="file"
                accept="image/*"
                ref="socialIcon"
                @change="selectCol2Image"
                required
            >
          </div>

          <div class="form-actions">
            <button class="btn-green" @click="sendCol2Data">Dodaj element</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header.js';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'FooterEdit',
  components: {HintComponent},
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      currentEditCol: 0,
      firstCol: {
        firstColData: {
          text: '',
          copyright: '',
          logo_url: '',
        },
      },
      secondCol: {
        secondColData: [],
        newElementName: '',
        newElementUrl: '',
        newElementImg: null,
      },
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getFirstCol();
    this.getSecondCol();
  },
  methods: {
    getFirstCol() {
      axios.get('/FooterSettingsGet')
          .then((res) => {
            if (res.data !== '') {
              this.firstCol.firstColData = res.data;
            }
          });
    },
    getSecondCol() {
      axios.post('/SocialIconSearch', { page: 0, limit: 50 })
          .then((res) => {
            this.secondCol.secondColData = res.data.items || [];
          });
    },
    toggleSocialForm() {
      this.currentEditCol = this.currentEditCol === 2 ? 0 : 2;
      if (this.currentEditCol === 0) {
        this.resetSocialForm();
      }
    },
    resetSocialForm() {
      this.secondCol.newElementName = '';
      this.secondCol.newElementUrl = '';
      this.secondCol.newElementImg = null;
      if (this.$refs.socialIcon) {
        this.$refs.socialIcon.value = '';
      }
    },
    selectCol2Image() {
      this.secondCol.newElementImg = this.$refs.socialIcon.files.item(0);
    },
    uploadCol1Data() {
      if (!this.firstCol.firstColData.text || !this.firstCol.firstColData.copyright) {
        this.appStore.setIsAlert('Uzupełnij wszystkie pola w kolumnie 1');
        return;
      }

      const ob = {
        text: this.firstCol.firstColData.text,
        copyright: this.firstCol.firstColData.copyright,
      };

      axios.post('/FooterSettings', ob)
          .then(() => {
            this.currentEditCol = 0;
            this.appStore.setIsSuccess('Zapisano zmiany w kolumnie 1');
            this.getFirstCol();
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się zapisać kolumny 1');
          });
    },
    sendCol2Data() {
      if (!this.secondCol.newElementName || !this.secondCol.newElementUrl || !this.secondCol.newElementImg) {
        this.appStore.setIsAlert('Uzupełnij nazwę, URL i wybierz ikonę');
        return;
      }

      const formData = new FormData();
      formData.append('icon', this.secondCol.newElementImg);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const ob = {
        name: this.secondCol.newElementName,
        url: this.secondCol.newElementUrl,
        icon: formData.get('icon'),
      };

      axios.post('/SocialIcon', ob, config)
          .then(() => {
            this.appStore.setIsSuccess('Dodano nowy element społecznościowy');
            this.getSecondCol();
            this.resetSocialForm();
            this.currentEditCol = 0;
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się dodać elementu');
          });
    },
    removeSocial(id) {
      axios.delete(`/SocialIcon/${id}`, authHeader())
          .then((res) => {
            if (String(res.status).charAt(0) === '2') {
              this.secondCol.secondColData = this.secondCol.secondColData.filter(item => item.id !== id);
              this.appStore.setIsSuccess('Usunięto element społecznościowy');
            }
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się usunąć elementu');
          });
    },
  },
};
</script>

<style scoped>
.footer-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.footer-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.section-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.first-col-preview {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  background: #fafafa;
}

.first-col-preview p {
  margin: 8px 0;
  font-size: 1.5rem;
  color: #4b5563;
}

.first-col-preview b {
  font-size: 1.4rem;
  color: #1f2937;
}

.footer-col-logo-img {
  width: 160px;
  max-width: 100%;
  margin-bottom: 8px;
}

.form-block {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group textarea {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.5rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.1);
}

.form-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.social-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.social-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #1f2937;
  min-width: 0;
}

.social-link img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.social-link span {
  font-size: 1.5rem;
  font-weight: 600;
  word-break: break-word;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-danger:hover {
  background-color: #fee2e2;
}

.empty-state {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

@media (max-width: 480px) {
  .footer-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green {
    width: 100%;
    text-align: center;
  }

  .section-card-header {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>